import React,{useState,useEffect} from 'react'
import ArticlesStyle from './ArticlesStyle.module.css'

//import components
import {getArticle} from '../../services/api'
//import material ui
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
//img
import img from '../../assets/photo.png'

const Article = () => {

    const[articles,setArticles]=useState([])

    useEffect(()=>{
        const data=async () => {
            setArticles(await getArticle() );

        }
        data()
    },[])
    
    return (
        <div className={ArticlesStyle.grid}>
      {articles.map((articles) => (
        <div className={ArticlesStyle.card}>
          <Card sx={{ maxWidth: 345 }} color="error">
            <CardMedia
              component="img"
              alt="green iguana"
              height="140"
              image={img
               
              }
            />
            <CardContent>
              <h2 style={{ fontSize: "18px", textAlign: "right" }}>
                {articles.title}
              </h2>
             

              <Typography variant="body2" color="text.secondary">{articles.text}</Typography>
            </CardContent>

            
          </Card>
        </div>
      ))}
    </div>
    )
}

export default Article
